import type { ReactNode } from 'react';
import { Card, Space, Typography, theme } from 'antd';

const { Title, Paragraph, Text } = Typography;

export type EducationPageChromeProps = {
  title: string;
  description?: string;
  extra?: ReactNode;
  tags?: ReactNode;
  children: ReactNode;
};

/** Shared Education page frame — matches Growth control-tower header density without a second dashboard engine. */
export default function EducationPageChrome({
  title,
  description,
  extra,
  tags,
  children,
}: EducationPageChromeProps) {
  const { token } = theme.useToken();

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Card
        size="small"
        styles={{
          body: {
            paddingBlock: 16,
            paddingInline: 20,
            background: `linear-gradient(135deg, ${token.colorBgContainer} 0%, ${token.colorFillAlter} 100%)`,
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
          },
        }}
      >
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'flex-start' }} wrap>
          <Space direction="vertical" size={4}>
            <Title level={3} style={{ margin: 0 }}>
              {title}
            </Title>
            {description ? (
              <Paragraph type="secondary" style={{ margin: 0, maxWidth: 720 }}>
                {description}
              </Paragraph>
            ) : null}
            {tags ? <Space wrap>{tags}</Space> : null}
          </Space>
          {extra ? <Space wrap>{extra}</Space> : null}
        </Space>
      </Card>
      {children}
    </Space>
  );
}

export function EducationMetaText({ children }: { children: ReactNode }) {
  return <Text type="secondary">{children}</Text>;
}
